import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import Modal from "react-modal";
import { MdOutlineClose } from "react-icons/md";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";

const DateFilterModal = ({
  visible,
  onDismiss,
  resetFilters,
  applyFilters,
  filterData = {},
  updateValue,
  minDate,
  maxDate,
  selectedDistrict = 'ALL'
}) => {
  const [localFilters, setLocalFilters] = useState({
    from_date: filterData.from_date || '',
    to_date: filterData.to_date || ''
  });

  // Update local filters when filterData changes
  useEffect(() => {
    setLocalFilters({
      from_date: filterData.from_date || '',
      to_date: filterData.to_date || ''
    });
  }, [filterData]);

  const handleApply = () => {
    if (localFilters.from_date && localFilters.to_date) {
      // Ensure from_date is before or equal to to_date
      const fromDate = moment(localFilters.from_date, 'YYYY-MM-DD');
      const toDate = moment(localFilters.to_date, 'YYYY-MM-DD');

      if (fromDate.isAfter(toDate)) {
        // If from_date is after to_date, swap them
        const temp = localFilters.from_date;
        setLocalFilters({
          from_date: localFilters.to_date,
          to_date: temp
        });
      }

      applyFilters({
        from_date: localFilters.from_date,
        to_date: localFilters.to_date,
        district: selectedDistrict
      });
    } else {
      // If either date is missing, reset filters
      handleReset();
    }
    onDismiss();
  };

  const handleReset = () => {
    setLocalFilters({
      from_date: '',
      to_date: ''
    });
    resetFilters();
    onDismiss(); // Close the modal after resetting
  };

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '350px', // Fixed width instead of percentage
            maxHeight: '90vh', // Use viewport height for better responsiveness
            overflow: 'visible', // Allow calendar to overflow
            borderRadius: '4px',
            outline: 'none',
            padding: '20px',
            backgroundColor: 'white',
        },
        overlay: {
            backgroundColor: 'rgba(0,0,0,0.8)',
            zIndex: 1300 // Ensure modal is above other elements
        }
    };

    // Simple popper configuration for the date picker
    const popperConfig = {
        modifiers: [
            {
                name: 'preventOverflow',
                options: {
                    rootBoundary: 'viewport',
                    tether: false,
                },
            },
        ],
    };

  // Parse min and max dates from props with validation
  const getValidDate = (dateStr, defaultDate = null) => {
    if (!dateStr) return defaultDate;
    const date = moment(dateStr, 'YYYY-MM-DD');
    return date.isValid() ? date.toDate() : defaultDate;
  };

  // Format date for display
  const formatDateForDisplay = (date) => {
    if (!date) return '';
    return moment(date).format('DD/MM/YYYY');
  };

    return (
        <Modal
            isOpen={visible}
            onRequestClose={() => { }}
            style={customStyles}
        >
            <div style={{ padding: '10px', paddingTop: '1px' }}>
                <h2>Range Filter</h2>
                <div onClick={onDismiss} style={{ position: 'absolute', top: '18px', right: '20px', cursor: 'pointer' }}>
                    <MdOutlineClose size={30} />
                </div>
                <div className="filter-option" style={{ marginBottom: '20px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>From Date:</label>
                  <div style={{ position: 'relative' }}>
                    <DatePicker
                      selected={getValidDate(localFilters.from_date)}
                      onChange={(date) => {
                        const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
                        setLocalFilters(prev => ({
                          ...prev,
                          from_date: formattedDate
                        }));
                      }}
                      placeholderText="DD/MM/YYYY"
                      dateFormat="dd/MM/yyyy"
                      selectsStart
                      startDate={getValidDate(localFilters.from_date)}
                      endDate={getValidDate(localFilters.to_date)}
                      minDate={minDate ? moment(minDate, 'YYYY-MM-DD').toDate() : null}
                      maxDate={maxDate ? moment(maxDate, 'YYYY-MM-DD').toDate() : null}
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={15}
                      popperPlacement="bottom-start"
                      popperConfig={popperConfig}
                      className="date-picker-input"
                      showPopperArrow={false}
                      isClearable
                    />
                  </div>
                </div>
                <div className="filter-option" style={{ marginBottom: '25px' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>To Date:</label>
                  <div style={{ position: 'relative' }}>
                    <DatePicker
                      selected={getValidDate(localFilters.to_date)}
                      onChange={(date) => {
                        const formattedDate = date ? moment(date).format('YYYY-MM-DD') : '';
                        setLocalFilters(prev => ({
                          ...prev,
                          to_date: formattedDate
                        }));
                      }}
                      placeholderText="DD/MM/YYYY"
                      dateFormat="dd/MM/yyyy"
                      selectsEnd
                      startDate={getValidDate(localFilters.from_date)}
                      endDate={getValidDate(localFilters.to_date)}
                      minDate={getValidDate(localFilters.from_date) || (minDate ? moment(minDate, 'YYYY-MM-DD').toDate() : null)}
                      maxDate={maxDate ? moment(maxDate, 'YYYY-MM-DD').toDate() : null}
                      showYearDropdown
                      scrollableYearDropdown
                      yearDropdownItemNumber={15}
                      popperPlacement="bottom-start"
                      popperConfig={popperConfig}
                      className="date-picker-input"
                      showPopperArrow={false}
                      isClearable
                    />
                  </div>
                </div>
                {localFilters.from_date || localFilters.to_date ? (
                  <div style={{ marginBottom: '15px', color: '#666', fontSize: '0.9em' }}>
                    {localFilters.from_date && (
                      <div>From: {formatDateForDisplay(localFilters.from_date)}</div>
                    )}
                    {localFilters.to_date && (
                      <div>To: {formatDateForDisplay(localFilters.to_date)}</div>
                    )}
                  </div>
                ) : null}
                <div className="filter-actions" style={{ marginTop: '20px' }}>
                    <button
                        onClick={handleApply}
                    >
                        Apply Filters
                    </button>
                    <button
                        onClick={handleReset}
                    >
                        Reset Filters
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default DateFilterModal
